import React from "react";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  shadow?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = "",
  shadow = true,
  ...props
}) => {
  const shadowClass = shadow ? "shadow-md" : "";
  return (
    <div
      className={`bg-white rounded-lg ${shadowClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  floated?: boolean;
  shadow?: boolean;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  className = "",
  floated = true,
  shadow = true,
  ...props
}) => {
  const floatedClass = floated ? "-mt-6 mb-4" : "";
  const shadowClass = shadow ? "shadow-lg" : "";
  return (
    <div
      className={`${floatedClass} ${shadowClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardBody: React.FC<CardBodyProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
};

interface CardFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardFooter: React.FC<CardFooterProps> = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <div className={`p-6 ${className}`} {...props}>
      {children}
    </div>
  );
};